import React from 'react';
import { API_URL } from '../config';

// Rarity translation map
const RARITY_TRANSLATIONS = {
  'common': 'comune',
  'rare': 'rara',
  'Common': 'Comune',
  'Rare': 'Rara',
  'rainbow': 'arcobaleno',
  'Rainbow': 'Arcobaleno',
  'legendary': 'leggendaria',
  'Legendary': 'Leggendaria',
  'epic': 'epica',
  'Epic': 'Epica',
  'uncommon': 'non comune',
  'Uncommon': 'Non Comune'
};

// Attribute translation map
const ATTRIBUTE_TRANSLATIONS = {
  'LIGHT': 'Luce',
  'DARK': 'Tenebre',
  'EARTH': 'Terra',
  'WATER': 'Acqua',
  'FIRE': 'Fuoco',
  'WIND': 'Vento',
  'DIVINE': 'Divino',
  'light': 'luce',
  'dark': 'tenebre',
  'earth': 'terra',
  'water': 'acqua',
  'fire': 'fuoco',
  'wind': 'vento',
  'divine': 'divino'
};

const translateRarity = (rarity) => {
  return RARITY_TRANSLATIONS[rarity] || rarity;
};

const translateAttribute = (attribute) => {
  return ATTRIBUTE_TRANSLATIONS[attribute] || attribute;
};

function CardModal({ card, onClose }) {
  const metadata = card.metadata ? (typeof card.metadata === 'string' ? JSON.parse(card.metadata) : card.metadata) : {};

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <div className="modal-card-container">
          <div className="modal-card-image">
            {card.jpeg_filename && (
              <img 
                src={`${API_URL}/cards/${card.jpeg_filename}`}
                alt={card.name}
                className="modal-card-img"
              />
            )}
          </div>
          
          <div className="modal-card-details">
            <div className="card-title-section">
              <h2>{card.name}</h2>
              {card.owner_username && (
                <div className="owner-badge">
                  <span className="owner-icon">👤</span>
                  <span className="owner-text">{card.owner_username}</span>
                </div>
              )}
            </div>
            
            {metadata.level && (
              <div className="detail-row">
                <strong>Livello:</strong> {metadata.level}
              </div>
            )}
            
            {metadata.type && (
              <div className="detail-row">
                <strong>Tipo:</strong> {metadata.type}
              </div>
            )}
            
            {metadata.attribute && (
              <div className="detail-row">
                <strong>Attributo:</strong> {translateAttribute(metadata.attribute)}
              </div>
            )}
            
            {metadata.rarity && (
              <div className="detail-row">
                <strong>Rarità:</strong> {translateRarity(metadata.rarity)}
              </div>
            )}
            
            {(metadata.atk || metadata.def) && (
              <div className="stats-container">
                {metadata.atk && (
                  <div className="stat-box">
                    <span className="stat-label">ATK</span>
                    <span className="stat-value">{metadata.atk}</span>
                  </div>
                )}
                {metadata.def && (
                  <div className="stat-box">
                    <span className="stat-label">DEF</span>
                    <span className="stat-value">{metadata.def}</span>
                  </div>
                )}
              </div>
            )}
            
            {metadata.effect && (
              <div className="effect-container">
                <strong>Effetto:</strong>
                <p className="effect-text">{metadata.effect}</p>
              </div>
            )}
            
            {card.purchase_price != null && (
              <div className="detail-row">
                <strong>Pagata:</strong> {Number(card.purchase_price).toLocaleString()} patapizze
              </div>
            )}

            {metadata.id && (
              <div className="detail-row">
                <strong>ID Carta:</strong> {metadata.id}
              </div>
            )}
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardModal;